import { render, staticRenderFns } from "./PostPet.vue?vue&type=template&id=735e8065&"
import script from "./PostPet.vue?vue&type=script&lang=js&"
export * from "./PostPet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports